export default {
    green: {
        detailed: [
            'Это внутренне сбалансированное состояние, при котором человек чувствует себя комфортно и безопасно. Его восприятие становится ясным и спокойным, он может сосредоточиться на происходящем, внимательно слушать, размышлять и принимать решения без излишней эмоциональности.',
            'Физически это проявляется в ровном дыхании, мягкой мимике, плавных движениях, заинтересованном взгляде, спокойной интонации и ясной речи. Человек в этом состоянии чаще всего спокоен, доброжелателен, открыт к диалогу и сотрудничеству.',
            'Состояние стабильности и внутренней гармонии, человек воспринимает окружающий мир без аффекта, создается спокойное и «безоценочное» состояние.',
            'Подходит для спокойной концентрации, изучения чего-либо нового, самопознания и рефлексии, осмысленных решений и внимательного слушания, взаимодействия с людьми, направленного на сотрудничество и достижение соглашения.',
            'Однако, если вам нужно жестко аргументировать свою точку зрения или быстро собрать нужную информацию в ограниченные сроки, такое состояние скорее не поможет.'
        ],
        resume: [
            'Итак, вы находитесь в зелёном квадрате — комфортный баланс и легкость внутри.',
            'Итак, вы находитесь в зелёном квадрате — мягкая гармония и ясный ум.',
            'Итак, вы находитесь в зелёном квадрате — спокойный и доброжелательный настрой.',
        ],
        mismatch: {
            yellow: ['Для выбранной задачи важны энтузиазм и быть на подъеме - это состояние желтого квадрата.',
            'Вы сейчас в состоянии спокойствия — это хороший старт, но для креатива и генерации оригинальных решений требуется больше энергии.'],
            red: ['Для выбранной задачи важно быть активным и напористым - это состояние красного квадрата.',
            'Вы сейчас в состоянии спокойствия — это может замедлить ваши действия.'],
            blue: ['Для выбранной задачи важны внимательность и концентрация внимания - это состояние синего квадрата.',
            'Вы сейчас в состоянии спокойствия — это хороший старт, но для данной задачи требуется большая сфокусированность на вопросе, что достигается за счет неприятных эмоций.'],
            green: [],
        },
        mismatch_recommendation: 'Если нет возможности сменить задачу, то рекомендуется перейти в эмоции зеленого квадрата, потому что он наиболее полезный для этой задачи. Эмоции зеленого квадрата обеспечивают внимательное слушание, способность достигать соглашения и находить общий язык с окружающими и т.п',
        description:  [
        {
            title: "Спокойная включённость",
            items: [
                'Внутренний баланс и ясность',
                'Мысли не бегают, всё по полочкам',
                'Готовность слушать, обсуждать, договариваться',
                'Комфорт в стабильной обстановке',
                'Подходят задачи без спешки'
            ]
        },
        {
            title: "Открытость и устойчивость",
            items: [
                'Эмоции ровные, нет перегруза',
                'Хорошо идёт сотрудничество',
                'Спокойный и взвешенный подход',
                'Есть ресурс поддержать других',
                'Уместны обсуждения и корректировки'
            ]
        },
        {
            title: "Спокойное развитие",
            items: [
                'Энергия ровная, но не высокая',
                'Спокойное, устойчивое состояние',
                'Подходит для обучения и усвоения нового',
                'Удобно планировать, систематизировать',
                'Погружение в состояние потока'
            ]
        },
        {
            title: "Тихая продуктивность",
            items: [
                'Эмоциональный ресурс стабилен',
                'Нет хаоса — есть возможность навести ясность',
                'Есть силы на качественное внимание',
                'Уместны задачи на улучшение процессов',
                'Хорошее состояние для завершения'
            ]
        }
    ],
    assessment: [
        'Есть чувство покоя и безмятежности.',
        'Тянет на природу и наслаждаться видами и звуками.',
        'Вы расслаблены и готовы впитывать информацию.',
        'Вам интересно и Вы открыты к новому.',
        'Вам комфортно и спокойно.'
    ]
    },
    blue: {
        detailed: ['Это состояние сниженной активности, при котором человек может ощущать некоторую усталость, потерю мотивации или легкую грусть, ностальгию. Несмотря на внешнюю пассивность, оно важно для глубокого самоосмысления, рефлексии, анализа, переоценки ценностей. Человек замедляется, может уходить в размышления, пересматривать свои действия и цели.',
            'На физическом уровне это состояние проявляется в опущенных плечах, пониженной мышечной активности, медленной речи, спокойных или грустных интонациях, опущенных уголках губ. Снижение активности, погруженность в себя, замедление.',
            'Благоприятно для самоанализа, подведения итогов, анализа неудач, поиска ошибок, переосмысления задач, уединенной и глубокой работы. В данном состоянии человеку легче различать эмоции других людей, понять глубокие чувства, проявить эмпатию и сочувствие другому.',
            'Может мешать действиям, требующим решимости, энергии и быстроты.'],
        resume: [
            'Итак, вы находитесь в синем квадрате — рефлексия и задумчивость.',
            'Итак, вы находитесь в синем квадрате — максимальная концентрация и аналитика.',
            'Итак, вы находитесь в синем квадрате — сосредоточенность и внимательность.'
        ],
        mismatch: {
            yellow: ['Для выбранной задачи важны энтузиазм и быть на подъеме - это состояние желтого квадрата.',
            'Сейчас вы в состоянии с низкой энергией и неприятными ощущениями. Данное состояние не способствует креативности и генерации оригинальных решений.'],
            red: ['Для выбранной задачи важно быть активным и напористым - это состояние красного квадрата.',
            'Сейчас вы в состоянии с низкой энергией. Это может замедлить ваши действия.'],
            blue: [],
            green: ['Для выбранной задачи важны спокойствие и расслабленность - это состояние зеленого квадрата.',
            'Сейчас вы в состоянии с низкой энергией и неприятными ощущениями. Это может замедлить ваши действия.'],
        },
        mismatch_recommendation: 'Если нет возможности сменить задачу, то рекомендуется перейти в эмоции синего квадрата, потому что он наиболее полезный для этой задачи. Эмоции синего квадрата обеспечивают внимательность, концентрацию, сфокусированность, усердность и т.п.',
        description: [
            {
                title: 'Размышляю о важном',
                items: [
                    'Спокойная концентрация на деталях',
                    'Настрой на «разбор полётов»',
                    'Полезен для наблюдений и глубокого анализа',
                    'Подходит для внутренних выводов и коррекции',
                    'В этом состоянии легче замечать ошибки и учиться на них'
                ]
            },
            {
                title: 'Не хочу ни с кем говорить',
                items: [
                    'Спокойствие на грани усталости — хочется подумать, но не действовать.',
                    'Мало энергии, но есть внимательность к деталям.',
                    'Хочется тишины, концентрации и времени на «переварить».',
                    'В этом состоянии легко замечать ошибки и делать выводы.',
                    'Подходит для тихой, глубокой, внутренней работы.'
                ]
            },
            {
                title: 'Состояние внутреннего сбора',
                items: [
                    'Хочется замедлиться и побыть в одиночестве',
                    'Энергии немного, внимание направлено внутрь',
                    'Возникает потребность в тишине и уединении',
                    'Желание рефлексии',
                    'Хорошо подходит для подведения итогов или пересборки'
                ]
            },
            {
                title: 'Нужна пауза',
                items: [
                    'Желание отсоединиться от внешнего мира',
                    'Мозг работает, внимание обращено внутрь',
                    'Возникает склонность к самокритике',
                    'Помогают тишина, простые рутинные действия, задачи на анализ и обдумывание',
                    'Подходит для анализа ошибок и жизненных поворотов'
                ]
            }
        ],
        assessment: [
            'Хочется завернуться в плед или включить музыку без слов.',
            'Вы сейчас замечаете каждую мелочь.',
            'Вы чувствуете ностальгию или легкую грусть.',
            'Тянет остаться в одиночестве и никому не отвечать.',
            'Тянет что-то обдумать или поразмышлять.'
        ],
    },
    yellow: {
        detailed: ['Это состояние вдохновения, восхищения, активной радости и удивления. Ощущается прилив энергии, желание действовать, пробовать новое, общаться, создавать и исследовать.',
            'Широкая улыбка, яркие глаза, быстрая речь, стремление двигаться, быстрые реакции и лёгкость в теле. Сопровождается энтузиазмом, бодростью и воодушевлением,',
            'Эмоции этого квадрата наполняют энергией, стимулируют исследование, творчество, стремление к новым идеям. Помогают быть активным, генерировать идеи и вовлекать других.',
            'Это подходящее состояние для творческих задач, мозговых штурмов, презентаций, старта новых инициатив, предрасполагает к творческой деятельности, вовлечению других людей в свои идеи и проекты.',
            'Однако критичность мышления может быть снижена — велик риск переоценки собственных идей и возможностей.'
            ],
        resume: [
            'Итак, вы находитесь в жёлтом квадрате — море энергии и фейерверк идей!',
            'Итак, вы находитесь в жёлтом квадрате — вы на позитиве и готовы творить.',
            'Итак, вы находитесь в жёлтом квадрате — драйв и вдохновение.'
        ],
        mismatch: {
            yellow: [],
            red: ['Для выбранной задачи важно быть активным и напористым - это состояние красного квадрата.',
            'У вас сейчас много энергии, но радостное возбуждение может мешать фокусировке на проблеме и сбивать настрой.'],
            blue: ['Для выбранной задачи важны внимательность и концентрация внимания - это состояние синего квадрата.',
            'У вас сейчас много энергии и воодушевления, что препятствует усидчивости и мешает удерживать фокус на задаче.'],
            green: ['Для выбранной задачи важны спокойствие и расслабленность - это состояние зеленого квадрата.',
            'У вас сейчас много энергии и воодушевления, что может препятствовать усидчивости и мешать удерживать фокус на задаче.'],
        },
        mismatch_recommendation: 'Если нет возможности сменить задачу, то рекомендуется перейти в эмоции желтого квадрата, потому что он наиболее полезный для этой задачи. Эмоции желтого квадрата обеспечивают креативность, способность вдохновлять и мотивировать, творческое и оригинальное решение вопросов и т.п',
        description: [
            {
                title: 'Вдохновляй и зажигай',
                items: [
                    'Полнота идей и энергии, внутренний драйв',
                    'Хочется делиться, вовлекать',
                    'Отлично идут мозговые штурмы',
                    'Легко заразить других энтузиазмом',
                    'Подходит для старта новых проектов'
                ]
            },
            {
                title: 'Сцена твоя',
                items: [
                    'На пике вдохновения',
                    'Яркое, заметное присутствие',
                    'Уверенно говорить перед аудиторией',
                    'Хорошо убеждать и вести за собой',
                    'Подходит для презентаций и выступлений'
                ]
            },
            {
                title: 'Командный мотор',
                items: [
                    'Социальная активность на максимуме',
                    'Много креативных мыслей',
                    'Хочется поддержать, мотивировать',
                    'Полезен для фасилитации и координации',
                    'Идеальное состояние для тимворка'
                ]
            },
            {
                title: 'Творческий поток',
                items: [
                    'В голове рождаются нестандартные идеи',
                    'Способность соединять несочетаемое',
                    'Интуитивные ходы работают на результат',
                    'Подходит для креативных решений и брейнштормов',
                    'Хочется делать, запускать, пробовать'
                ]
            }
        ],
        assessment: [
            'Хочется кому-то что-то рассказать или поделиться идеей.',
            'Хочется танцевать или включить бодрую музыку.',
            'Вы чувствуете бодрость и легкость.',
            'Вас переполняют предвкушение и радость.',
            'Хочется улыбаться.'
        ]
    },
    red: {
        detailed: ['Это высоко энергичное состояние, сопровождается приливом сил, энергии и решительности, повышает уверенность в себе, мобилизует все силы организма, дает энергию на отстаивание своей позиции и защиту своих интересов и  границ.',
            'Может сопровождаться учащенным дыханием, резкими, активными движениями/ жестами, повышенным тоном голоса, напряженной мимикой и быстрыми импульсивными реакциями.',
            'Помогает действовать решительно, добиваться своего, бороться за справедливость, быстро принимать решения в критических ситуациях. В краткосрочной перспективе усиливает мотивацию и настойчивость, но требует саморегуляции, чтобы не привести к деструктивным последствиям.',
            'Это хорошее состояние для задач, где нужно настоять на своем, уверенно аргументировать свою точку зрения, вступить в открытое противостояние или быстро отреагировать на сложную ситуацию.',
            'Однако в этом состоянии легко допустить ошибку или испортить отношения, поэтому важно осознавать свои эмоции и управлять ими.'],
        resume: [
            'Итак, вы находитесь в красном квадрате — энергия кипит и чувствуется готовность к защите или нападению.',
            'Итак, вы находитесь в красном квадрате — напряжение высоко.',
            'Итак, вы находитесь в красном квадрате — бдительность и уверенная аргументация.'
        ],
        mismatch: {
            yellow: [
                'Для выбранной задачи важны энтузиазм и быть на подъеме - это состояние желтого квадрата.',
                'У вас сейчас много энергии, но неприятные ощущения. Данное состояние не способствует креативности и генерации оригинальных решений.'
            ],
            red: [],
            blue: ['Для выбранной задачи важны внимательность и концентрация внимания - это состояние синего квадрата.',
            'У вас сейчас много энергии, но данное состояние не способствует усидчивости и сосредоточенности.'],
            green: ['Для выбранной задачи важны спокойствие и расслабленность - это состояние зеленого квадрата.',
            'У вас сейчас много энергии, но неприятные ощущения. Данное состояние не способствует сонастройке с собеседником.'],
        },
        mismatch_recommendation: 'Если нет возможности сменить задачу, то рекомендуется перейти в эмоции красного квадрата, потому что он наиболее полезный для этой задачи. Эмоции красного квадрата обеспечивают активность, бдительность, напористость, выносливость и т.п',
        description: [
            {
                title: 'На пике напряжения',
                items: [
                    'Всё внимание - на угрозу или вызов',
                    'Тело напряжено и готово к усилию',
                    'Готовность защищать свои границы',
                    'Полнота энергии и решимости',
                    'Подходит для жёстких переговоров и отстаивания позиции'
                ]
            },
            {
                title: 'Режим борьбы',
                items: [
                    'Внутреннее напряжение высокое',
                    'Всё кажется срочным и важным',
                    'Есть риск сорваться или обострить конфликт',
                    'Эффективность в отстаивании границ или конкурентной среде',
                    'Подходит для ситуаций, где надо быть жёстким'
                ]
            },
            {
                title: 'Активация: срочно действовать',
                items: [
                    'Чувство, что надо решать всё немедленно',
                    'Мышление - реактивное, решения - быстрые',
                    'Полнота энергии, но возможно - на грани выгорания',
                    'Подходит для антикризисных задач',
                    'Эффективность, когда нужен прорыв, но не надолго'
                ]
            },
            {
                title: 'Максимальная мобилизация',
                items: [
                    'Всё внимание сфокусировано на проблеме',
                    'Прилив энергии и готовность  действовать',
                    'Хочется доказать, повлиять, победить',
                    'Высокое эмоциональное влияние',
                    'Подходит для публичного отстаивания идей, мотивации команды'
                ]
            }
        ],
        assessment: [
            'Хочется кричать или резко ответить кому-то.',
            'Есть ощущение, что «всё бесит».',
            'Хочется ударить, рвануть, повысить голос.',
            'Хочется разбить что-то.',
            'Ощущается легкое раздражение.',
        ]
    }
}
